
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from 'vue'
import etxaldemapa from '../vue/etxaldemapa.vue'

Vue.component('etxalde-mapa-component', etxaldemapa);


export default {
  init() {
    // JavaScript to be fired on the home page
    new Vue({
      el: '#app',
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/etxaldemapa.js